import Languages from './Languages';

function getUserPreferredLanguages() {
    const preferredLanguages = window.navigator.languages || [
        window.navigator.language || window.navigator.userLanguage,
    ];

    return preferredLanguages;
}

function getShortLang(lang) {
    if (lang.indexOf('-') !== -1) {
        return lang.split('-')[0];
    }
    if (lang.indexOf('_') !== -1) {
        return lang.split('_')[0];
    }
    return lang;
}

function findSupportedLanguage(lang) {
    return Object.entries(Languages).find(([, { browserLanguageKey, testShortForm }]) =>
        browserLanguageKey.includes(testShortForm ? getShortLang(lang) : lang),
    );
}

export default function getUserPreferredLanguage() {
    const userPreferredLanguage = getUserPreferredLanguages()
        .map(findSupportedLanguage)
        .filter(Boolean)
        .map((supportedLanguage) => supportedLanguage[0]);
    return userPreferredLanguage.length ? userPreferredLanguage[0] : 'en';
}
